import { AxiosResponse } from 'axios';

// import { BankInfoFormState } from '../../pages/profile/company/bank';
import { MainInfoFormState } from '../../pages/profile/company/components/main';

import { CompanyInfoResponse } from './dto/Company';
import BaseApi from './BaseApi';

const companyApi = {
  getCompanyInfo(token?: string): Promise<AxiosResponse<CompanyInfoResponse>> {
    const headers = {} as Record<string, any>; // TODO: configure BaseApi in signup flow
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return BaseApi.get('/api/v1/personal/company', { headers });
  },

  updateCompany(
    payload: { orgId: number } & (MainInfoFormState)
  ): Promise<AxiosResponse<any>> {
    return BaseApi.post('/api/v1/administration/company/update', payload);
  },

  getRelatedCompanies(
    token?: string
  ): Promise<AxiosResponse<CompanyInfoResponse[]>> {
    const headers = {} as Record<string, any>; // TODO: configure BaseApi in signup flow
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    return BaseApi.get('/api/v1/common/info/companies');
  },
  keyRecovery(
    token: string,
    payload: {
      pubKey: string;
      signature: string;
    }
  ): Promise<AxiosResponse> {
    return BaseApi.post(
      '/api/v1/administration/company/key/recovery',
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
};

export default companyApi;
